import React from "react";
import { CondensationBackground } from "./condensation/CondensationBackground";

export function ElementsCollection({ variant, ...props }) {
  if (variant === "condensation") {
    return <CondensationBackground {...props} />;
  }
  return null;
}
